import { useQuery } from "react-query";
import { getImages } from "../services/SlideApi";


const useExplore = (key = null) => {
    return useQuery(['explore', key], () => getImages(key))
}
 
export default useExplore;